import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5, P } from '../../../AbstractElements';
import ApexChart from 'react-apexcharts';
import { ProfitOverviewOption } from '../../../Data/DashBoard/Default/Chart';
import { ProfitOverviewTitle, YearlyCompanyGrowthMonthWise } from '../../../Constant';

const ProfitOverview = () => {
  return (
    <Col xl='4' md='6' className='xl-30'>
      <Card className='profitview-sec'>
        <CardHeader className='card-no-border'>
          <H5>{ProfitOverviewTitle}</H5>
          <div className='center-content'>
            <P>{YearlyCompanyGrowthMonthWise}</P>
          </div>
        </CardHeader>
        <CardBody className='p-0'>
          <ApexChart options={ProfitOverviewOption.options} series={ProfitOverviewOption.series} type='radar' height={370} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ProfitOverview;
